import axios from "axios";

export default () => {
  const CancelToken = axios.CancelToken;
  return CancelToken.source();
};
